import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What are cloud infrastructure management services?",
    answer: `<p>Cloud infrastructure management can be described as the best practices and tools that relate to the allocation and delivery of key resources on demand.</p>
    <p>This encompasses activities such as allocating, setting up, and overseeing cloud resources using tools and APIs. A dashboard or UI could be an ideal example, for managing resources like Virtual machines, storage, and networks efficiently and securely in the cloud infrastructure.</p>`,
  },
  {
    question: "What are managed infrastructure services in the cloud?",
    answer: `<p>Cloud-managed infrastructure services entail outsourcing cloud resource management to a third-party supplier, which includes provisioning, monitoring, and maintenance. This enables businesses to concentrate on their core business while maintaining efficient, secure, and scalable cloud operations.</p>
    <p>These services are frequently provided on a contract basis, with the MSP being required to meet a set of agreed-upon requirements to profit from the contract.</p>`,
  },
  {
    question: "What is an infrastructure management service?",
    answer: `<p>IMS refers to the systematic and purposeful management of technology, information, and data across several domains. These include the management of desktops, networking, storage, data, security, and cloud services, as well as the workers who maintain them.</p>`,
  },
  {
    question: "What is the role of cloud infrastructure services?",
    answer: `<p>Cloud infrastructure makes it simple for communities and groups to collaborate on the same files, regardless of where they are in the world. Additionally, a lot of cloud service providers offer 24/7 support, software updates, maintenance, and security enhancements.</p>`,
  },
  {
    question: "What is the difference between cloud and managed services?",
    answer: `<p>Cloud service providers handle the administration of the physical infrastructure and provide cloud-based solutions including platforms, software, and equipment.</p>
    <p>On the other hand, Managed service providers, don't control the underlying infrastructure; instead, they focus on managing and supporting IT services like networking, cybersecurity, and data backup.</p>`,
  },
  {
    question: "What does a cloud infrastructure manager do?",
    answer: `<p>A cloud infrastructure manager is responsible for configuring and optimizing cloud resources, managing deployments, and ensuring compliance with security and governance policies within an organization's cloud environment.</p>`,
  },
  {
    question: "What is managed cloud infrastructure?",
    answer: `<p>Cloud infrastructure management in cloud computing comprises services where providers manage and monitor all or some of a client's cloud resources, including continuous maintenance, security enforcement, performance optimization, migration, and setup.</p>`,
  },
  {
    question: "Why do we need cloud infrastructure?",
    answer: `<p>Cloud infrastructure is important for efficient data backup and disaster recovery capabilities, which protect data from possible losses due to hardware failures, cybersecurity attacks, or human mistakes, assuring business continuity and data integrity.</p>`,
  },
  {
    question: "What is cloud management software?",
    answer: `<p>Cloud management offers cost management, reporting, and accurate estimation to help you get the right understanding of what and when resources are being used. This can help you save expenses, determine whether you're getting what you paid for, and spend resources more wisely.</p>`,
  },
  {
    question:
      "Why should I hire an infrastructure management company for my business?",
    answer: `<p>Hiring an infrastructure management company allows you to concentrate on your primary business goals while enhancing efficiency and security through skilled administration of IT operations.</p>`,
  },
  {
    question: "What types of cloud infrastructures your team can manage?",
    answer: `<p>Our staff is experienced in operating a variety of cloud infrastructures, including public clouds such as AWS, Azure, and Google Cloud Platform. We also manage private cloud systems that are suited to specific corporate requirements. In addition, we specialize in hybrid cloud configurations, which smoothly mix public and private clouds.</p>`,
  },
  {
    question:
      "Can you help us migrate our existing infrastructure to the cloud?",
    answer: `<p>Yes, we do provide migration services starting from planning to deployment. We find out your existing infrastructure, and migration plan, and execute the migration process in a manner that has the least impact on your operations. We have a wealth of experience to help choose the appropriate cloud solution, simplify the process of moving to the platform, and address issues that may arise after migration.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#F8F8FB" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Cloud Infrastructure FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
